<template>
  <div v-if="theme === 'theme2'" class="nc-text">
    <div v-if="label" class="text-uppercase mb-1" style="letter-spacing: 2px; font-size: 12px">
      {{ label }}
      <span v-if="isRequired" style="color: #ff0000; font-size: 14px">*</span>
    </div>
    <div class="d-flex flex-row" style="column-gap: 15px">
      <label v-for="(option, index) in options" :key="`radio-option-${index}`" class="form-radio w-radio">
        <div
          class="w-form-formradioinput w-form-formradioinput--inputType-custom form-radio-icon w-radio-input n-cursor-pointer"
          :class="childModelValue === option.value ? 'w--redirected-checked' : ''"
        ></div>
        <input
          :id="`radio-option-${index}`"
          v-model="childModelValue"
          type="radio"
          :name="name"
          :data-name="name"
          style="opacity: 0; position: absolute; z-index: -1"
          :value="option.value"
          @change="$emit('onChanged')"
        />
        <span class="form-radio-label w-form-label" :for="`radio-option-${index}`">
          {{ option.label }}
        </span>
      </label>
    </div>
  </div>
  <div v-else-if="theme === 'theme3'" class="tw-flex tw-flex-col">
    <library-text v-if="label" :text="label" type="input-label" class="tw-mb-1 tw-capitalize"> </library-text>
    <div class="tw-flex tw-flex-wrap tw-gap-x-4">
      <div v-for="(option, index) in options" :key="`radio-option-${index}`" class="tw-flex tw-items-center">
        <input
          :id="`radio-option-${index}`"
          v-model="childModelValue"
          type="radio"
          class="tw-h-4 tw-w-4"
          :class="radioColorClass"
          :value="option.value"
          :name="name"
          :data-name="name"
          :checked="option.value === childModelValue"
          @change="$emit('onChanged')"
        />
        <label :for="`radio-option-${index}`" class="tw-ml-2 tw-block tw-text-base tw-font-medium">
          <lazy-library-text :text="option.label"></lazy-library-text>
        </label>
      </div>
    </div>
  </div>
  <div v-else class="tw-flex tw-flex-col">
    <library-text v-if="label" :text="label" type="input-label" class="tw-mb-1 tw-capitalize"> </library-text>
    <div class="tw-flex tw-flex-wrap tw-gap-x-4">
      <div v-for="(option, index) in options" :key="`radio-option-${index}`" class="tw-flex tw-items-center">
        <input
          :id="`radio-option-${index}`"
          v-model="childModelValue"
          type="radio"
          class="tw-h-4 tw-w-4"
          :class="radioColorClass"
          :value="option.value"
          :name="name"
          :data-name="name"
          :checked="option.value === childModelValue"
          @change="$emit('onChanged')"
        />
        <label :for="`radio-option-${index}`" class="tw-ml-2 tw-block tw-text-base tw-font-medium">
          <lazy-library-text :text="option.label"></lazy-library-text>
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { mapState } from 'pinia';
import { produceKey } from '~/server/core/helpers';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'NcRadio',

  data() {
    return {
      key: produceKey(),
    };
  },

  props: {
    modelValue: {
      required: true,
    },

    label: {
      required: false,
      type: String,
      default: null,
    },

    name: {
      required: false,
      type: String,
      default: null,
    },

    placeholder: {
      required: false,
      type: String,
      default: null,
    },

    isRequired: {
      required: false,
      type: Boolean,
      default: false,
    },

    options: {
      required: false,
      type: Array as PropType<{ value: any; label: string }[]>,
      default: () => [],
    },
  },

  emits: ['update:modelValue', 'onChanged'],

  computed: {
    ...mapState(useWebsiteStore, ['theme']),

    childModelValue: {
      get() {
        return this.modelValue;
      },
      set(value: string) {
        this.$emit('update:modelValue', value);
      },
    },

    radioColorClass() {
      if (this.theme === 'theme3') {
        return 'checked:tw-accent-[var(--purple)]';
      }
      return 'checked:tw-accent-[var(--browns)]';
    },
  },
});
</script>

<style scoped></style>
